import { IMatchLiveData } from '@/models/match-live-data';
import { useMemo } from 'react';

export const useCombinedEvents = (liveData?: IMatchLiveData) => {
	return useMemo(() => {
		if (!liveData) return []; // Handle case where liveData is undefined

		try {
			const goals = liveData.goal || [];
			const cards = liveData.card || [];
			const substitutes = liveData.substitute || [];
			const missedPen = liveData.missedPen || [];
			const filteredMissedPen = missedPen.filter((obj) => obj.type === 'PM');

			const combinedArray = [
				...goals.map((obj) => ({ ...obj, eventType: 'goal' })),
				...cards.map((obj) => ({ ...obj, eventType: 'card' })),
				...substitutes.map((obj) => ({ ...obj, eventType: 'substitute' })),
				...filteredMissedPen.map((obj) => ({ ...obj, eventType: 'missedPen' })),
			];

			combinedArray.sort((a, b) => a.timeMin - b.timeMin);
			return combinedArray;
		} catch {
			return [];
		}
	}, [liveData]);
};
